'use strict'

export let norwegian={
  period: {
    hideCalendar: "Skjul kalender",
    from: "Fra",
    to: "til",
    pleaseSelect: "Vennligst angi",
    firstDay:"første dag",
    lastDay: "siste dag",
    fromUndefinedTo: "Fra <udefinert> til",
    months: ["Januar","Februar","Mars","April","Mai","Juni","Juli","August","September","Oktober","November","Desember"],
    weekdaysShort: ["Sø", "Ma", "Ti", "On", "To","Fr", "Lø"],
  },
  status: {
    green: "Prognoser er innenfor toleransegrensene",
    yellow: "Saker eller risiko har oppstått. Hvis det ikke blir håndtert vil etappen eller prosjektets prognose ende opp med å overskride toleransegrensene",
    red: "Prognosene overskrider toleransegrensene. En unntaksplan er nødvendig."
  },
  form: {
    cancel: "Lukk / Avbryt",
    add: "Legg til",
    update: "Oppdater",
    delete: "Slett",
    confirmDeleteMessage: "Vil du slette denne leveransen?",
    cancelDelete: "Avbryt",
    changesAreSaved: "Endringene er lagret!"
  },
  menu: {
    approve: "Godkjenn",
    retractRequest: "Trekk tilbake forespørsel",
    request: "Forespør",
    recommend: "Anbefal",
    retract: "Trekk tilbake",
    progress: "Fremdrift",
    status: "Status",
    startProject: "Start projekt",
    pauseProject: "Pause prosjekt",
    stopProject: "Stop projekt",
    startProgramme: "Start program",
    pauseProgramme: "Pause program",
    stopProgramme: "Stop program",
    actions: "Handlinger",
    editProperties: "Rediger egenskapene",
    openLog: "Åpne logg",
    projectSettings: "Prosjektinnstillinger",
    cloneProject: "Klone prosjektet",
    prepareProjectClosure: "Forbered prosjektavslutning"
  }
}



// WEBPACK FOOTER //
// ./views/components/labels/norwegian.js